import { NODE_TYPE } from '@/lib/nodeType';

export const dataList = [];

export const generateList = data => {
    data.forEach(item => {
        const { key, title, children } = item;
        dataList.push({ key, title });

        if (children) {
            generateList(children);
        }
    });
};

export const getParentKey = (key, tree) => {
    let parentKey;

    tree.forEach(treeItem => {
        if (treeItem.children) {
            if (treeItem.children.some(item => item.key === key)) {
                parentKey = treeItem.key;
            } else if (getParentKey(key, treeItem.children)) {
                parentKey = getParentKey(key, treeItem.children);
            }
        }
    });

    return parentKey;
};

/* toParams - метод, формирующий готовый объект для серверных запросов. */
export const toParams = item => {
    const result = {};
    if (item) {
        const { id, node, parents } = item;
        const treeItems = [{ id, node }, ...parents];

        for (const treeItem of treeItems) {
            const { id, node } = treeItem;
            const property = `${node}Id`;
            result[property] = id;
        }
    }

    return result;
};

/* addParents - метод, формирующий список родителей узла в иерархичном порядке. */
const addParents = (list = [], parentNode = {}) => {
    return list.map(listItem => {
        let parents = [];
        if (parentNode.parents) parents = [{ id: parentNode.id, node: parentNode.node }, ...parentNode.parents];

        return { ...listItem, parents };
    });
};

export const updateTreeData = (list, key, children) => {
    if (!list) {
        return addParents(children);
    }

    return list.map(node => {
        if (node.key === key) {
            const childrenWithParents = addParents(children, node);
            return { ...node, children: childrenWithParents };
        }
        if (node.children) {
            return { ...node, children: updateTreeData(node.children, key, children) };
        }

        return node;
    });
};

export const findItemByKey = (key, list) => {
    if (!list) {
        return undefined;
    }

    for (const item of list) {
        if (item.key === key) {
            return item;
        }
        if (item.children) {
            const foundedItem = findItemByKey(key, item.children);
            if (foundedItem) {
                return foundedItem;
            }
        }
    }
};

const EXCLUDE_NODES = ['wellInProfile'];

export const filterByStatuses = (data = [], statuses = [], parentKey, groupFilterValue) => {
    const newDataMap = new Map();
    if (Array.isArray(data)) {
        data.forEach(item => {
            if (item.node === NODE_TYPE.WELL && !EXCLUDE_NODES.includes(item.nodeType)) {
                // Поле group используется, если выбранны "Неглубокие скважины" в виде дерева
                const filterField = groupFilterValue === 'itemNotDeepWell' ? 'group' : 'statusCode';
                const foundStatusIndex = statuses.findIndex(({ code }) => {
                    if (Array.isArray(code)) return code.includes(item[filterField]);
                    return code === item[filterField];
                });
                const foundStatus = statuses[foundStatusIndex];
                if (foundStatus) {
                    if (newDataMap.has(foundStatus.key)) {
                        const foundStatusData = newDataMap.get(foundStatus.key);
                        foundStatusData.children.push(item);
                        newDataMap.set(foundStatus.key, foundStatusData);
                    } else {
                        newDataMap.set(foundStatus.key, {
                            ...foundStatus,
                            key: `${foundStatus.key}_${parentKey}`,
                            index: foundStatusIndex,
                            node: 'status',
                            nodeType: `status${foundStatus.key}`,
                            isLeaf: false,
                            children: [item],
                        });
                    }
                }
            } else {
                if (item.children) {
                    const children = filterByStatuses(item.children, statuses, item.key, groupFilterValue);
                    newDataMap.set(item.key, { ...item, children });
                } else {
                    newDataMap.set(item.key, item);
                }
            }
        });
    }

    const newDataArray = [...newDataMap.values()];
    const sortedNewDataArray = newDataArray.sort(
        ({ index: firstIndex = 0 }, { index: secondIndex = 0 }) => firstIndex - secondIndex,
    );

    return sortedNewDataArray;
};

export const getCheckedItemCode = data => {
    const value = data.filter(({ checked }) => checked).map(({ code }) => code);

    if (value.length === 1) {
        return value[0];
    }

    return '';
};
